<template>
    <div>
        <CRow>
            <CCol md="12">

            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                                <strong>{{$t('AddSalesPlan')}}</strong>

                            </CCol>

                            <CCol col="4" style="text-align: end">
                                <CButton @click="insert_data()"
                                         class="mr-1"
                                         size="sm"
                                         color="secondary">
                                    {{ $t('buttons.save') }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>

                            <CCol col="3">
                                <CRow form class="form-group">
                                    <div tag="label" sm="4" class="col-form-label">
                                        {{$t('month')}}
                                    </div>
                                    <div sm="8">
                                        <date-picker
                                                v-if="$i18n.locale!='fa'"
                                                :label="$t('month')"
                                                type="month"
                                                input-format="MM"
                                                format="MM"
                                                alt-format="MM"

                                                display-format="MM MMM"
                                                :auto-submit="false"
                                                v-model="start_date"></date-picker>
                                        <date-picker
                                                v-if="$i18n.locale=='fa'"
                                                :label="$t('month')"
                                                type="month"
                                                display-format="jMM jMMM"
                                                format="MM"
                                                :auto-submit="false"
                                                v-model="start_date"></date-picker>
                                    </div>
                                </CRow>

                            </CCol>
                            <CCol col="3">
                                <CSelect
                                        :label="$t('country')"
                                        :value.sync="selected_country"
                                        :options="country_items"
                                />
                            </CCol>
                            <CCol col="3">
                                <CSelect
                                        :label="$t('components.province')"

                                        :options="province_items"
                                        :value.sync="selected_province"/>

                            </CCol>
                            <CCol col="3">
                                <CSelect
                                        :label="$t('components.city')"

                                        :options="city_items"
                                        :value.sync="selected_city"/>

                            </CCol>
                            <CCol col="6">
                                <CInput
                                        :label="$t('components.summary')"

                                        v-model="summary"
                                />

                            </CCol>


                        </CRow>
                        <hr>
                        <CRow>
                            <CCol col="3">
                                <CSelect
                                        :value.sync="selected_category"
                                        :options="category_items"
                                />
                            </CCol>

                            <CCol col="3">
                                <treeselect
                                        v-model="selected_product"
                                        valueFormat="object"
                                        :normalizer="normalizer_products"
                                        :async="true"
                                        :loadOptions="load_products"
                                        :placeholder="$t('components.search')"
                                />
                            </CCol>

                            <CCol col="1">
                                <CButton @click="add_product_to_list" size="sm" color="secondary">
                                    <CIcon size="sm" name="cil-plus"/>
                                </CButton>
                            </CCol>
                            <CCol col="1">
                                <CButton @click="items=[]" size="sm" color="secondary">
                                    <CIcon size="sm" name="cil-trash"/>
                                </CButton>
                            </CCol>

                        </CRow>
                        <CDataTableFixed
                                :items="items"
                                :fields="fields"
                                height="280px"
                                :items-per-page="2000"
                                hover
                                border
                                striped
                                sorter
                                pagination
                        >
                            <template #row="{item,index}">
                                <td>
                                    <p style="text-align: center">{{index+1}}</p>
                                </td>
                            </template>
                            <template #amount="{item}">
                                <td>
                                    <p style="text-align: right" v-if="item.amount!=null">{{get_currency(item.amount)}}</p>
                                </td>
                            </template>
                            <template #qty="{item}">
                                <td>
                                    <p style="text-align: center">{{item.qty}}</p>
                                </td>
                            </template>
                            <template #preQty="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(Math.abs(item.preQty))}}</p>
                                </td>
                            </template>
                            <template #productCode="{item}">
                                <td>
                                    <p style="text-align: center">{{item.productCode}}</p>
                                </td>
                            </template>
                            <template #currentSaleQty="{item}">
                                <td>
                                    <CInput
                                            @keypress="isNumber($event)"

                                            v-model="item.currentSaleQty"/>
                                </td>
                            </template>
                            <template #currentSaleAmount="{item}">
                                <td>
                                    <p style="text-align: right" v-if="item.currentSaleQty!=null">{{get_currency(item.amount*item.currentSaleQty)}}</p>
                                </td>
                            </template>

                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td>
                                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                           :value="item.id"/>
                                </td>
                            </template>
                            <template #under-table>
                                <CRow>

                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol>{{ $t('totalCirculation') }}</CCol>
                                    <CCol>{{ get_currency(get_sum_credetor(items)) }}</CCol>

                                </CRow>


                            </template>
                        </CDataTableFixed>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    export default {
        name: 'Login',
        components: {
            Treeselect,
        },
        data() {
            return {
                province_items: [],
                selected_province: 0,
                check_all_exit: false,
                id_checkbox_items: [],
                city_items: [],
                selected_city: 0,
                summary: '',
                country_items: [],
                selected_country: 0,

                validate_errors: [],
                selected_product: null,
                name: '',
                start_date: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                category_items: [],
                selected_category: 0,
                items: [],
                fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
                    {key: 'productName', label: this.$t('item'), _style: 'width:20%'},
                    {key: 'productCode', label: this.$t('tables.code'), _style: 'width:10%'},
                    {key: 'preQty', label: this.$t('PreSaleQty'), _style: 'width:10%;'},
                  {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%;'},
                  {key: 'currentSaleQty', label: this.$t('currentSaleQty'), _style: 'width:10%;'},
                  {key: 'currentSaleAmount', label: this.$t('totalAmount'), _style: 'width:10%;'},
                    {key: 'select', label: '', _style: 'width:5%;'},
                ],


                document_person: null,

                details: [],
                collapseDuration: 0,
                status_form: 0,
                load_products({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetProductsForPlan', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.productCode + " " + node.productName,

                    }
                },
            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];


            this.start_date = moment().locale('en').format("MM");
            this.get_categories();
            this.get_country();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        },
        watch: {
            'check_all_exit': function () {
                if (this.check_all_exit) {
                    this.items.forEach(function (val) {
                        this.id_checkbox_items.push(val.id);
                    })
                } else {
                    this.id_checkbox_items = [];
                }
            },
            'selected_province': function () {
                console.log("peovince changed");
                this.get_cities();
            },
            'selected_country': function () {
                this.get_provinces();
            },
        },
        methods: {
            get_sum_credetor(list) {
                var sum = 0;
                list.forEach((val) => {
                    if (val.currentSaleQty != null && val.amount != null) {
                        val.amount = val.amount.toString().replace(/,/g, '');
                        val.currentSaleQty = val.currentSaleQty.toString().replace(/,/g, '');

                        sum += parseFloat(val.currentSaleQty) * parseFloat(val.amount);

                    }
                })
                return sum;
            },
            add_product_to_list() {
                if (this.selected_product != null) {
                    console.log("add product", this.selected_product)
                    this.items.push(this.selected_product);
                    this.selected_product = null;
                } else {
                    this.get_category_products()
                }
            },
            get_category_products() {
                var self = this;
                const formData = new FormData();
                formData.append('CatRelId', this.selected_category);
                axios.post('GetProductsForPlan', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        content_data.data.forEach(function (val) {
                            self.items.push(val);
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];

                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');

                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.province_items = [];
                        self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id', 'provinceName');


                        self.selected_province = self.province_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.city_items = []
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');

                        self.selected_city = self.city_items[0].value;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_categories() {
                var self = this;


                const formData = new FormData();

                axios.post('GetAllCats', formData, {
                    params: {
                        // isparent : self.$route.params.cat_id
                    },
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.category_items = [];
                        var obj = {label: self.$t('dialogs.insertCategory'), value: 0}
                        self.category_items.push(obj);
                        self.category_items = self.sort_array(
                            self.category_items, content_data.data,
                            'catTitleId', 'catTitle');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            goToAddTarget() {
                this.$router.push({path: "/dashboard/delivery/add-visitor-target"})
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.areaName;
                this.selected_province = item.provinceId;
                this.selected_city = item.cityId;
                this.get_cities();
                this.polygon_area = JSON.parse(item.areaRange);
                this.show_polygon();

                this.status_form = item.id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            goSubCategories(item, index) {

                this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            insert_data() {

                if (this.id_checkbox_items.length == 0) {
                    this.$root.root_validate_errors.push(this.$t('selectOneProduct'));
                    return;
                }
                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddSalePlanMaster";
                } else {
                    url = "AddSalePlanMaster";
                    formData.append('id', this.status_form)
                }


                // Items =>json bede =>ProductId Qty Amount  TotalAmount
                var json = [];
                var validation = true
                self.id_checkbox_items.forEach(function (val) {
                    var product = self.items.filter(x => x.id == val)[0];
                    if (product.amount == null || product.currentSaleQty == null) {
                        validation = false;
                    }
                    json.push({
                        ProductId: product.id,
                        Qty: product.currentSaleQty,
                        Amount: product.amount,
                        TotalAmount: parseFloat(product.amount) * parseFloat(product.currentSaleQty)
                    })
                })
                if(validation == false){
                    self.$root.root_validate_errors.push(self.$t('selectOneProduct'));
                    return;
                }

                var date = moment(moment().locale('en').format("YYYY") + "-" + this.start_date + "-" + "01");
                var date2 = moment(moment().locale('en').format("YYYY") + "-" + this.start_date + "-" + "01");
                // date.setFullYear(this.selected_year,this.start_date,1);
                // date2.setFullYear(this.selected_year,this.start_date,1);
                var last_day2 = new Date(date2)
                var last_day = new Date(last_day2.getFullYear(), last_day2.getMonth() + 1, 0)

                // moment(date).locale('en').format('YYYY-MM-DD')
                // formData.append('FromDate', moment(date).locale('en').format('YYYY-MM-DD'));
                formData.append('MonthNo', moment(last_day).locale('en').format('YYYY-MM-DD'));

                // formData.append('MonthNo', this.start_date);
                formData.append('CategoryId', this.selected_category);
                formData.append('Country', this.selected_country);
                formData.append('CityId', this.selected_city);
                formData.append('County', this.selected_province);
                formData.append('Summary', this.summary);
                formData.append('Items', JSON.stringify(json));
                axios.post(url, formData, {}).then((res) => {


                    self.$root.modal_component.show_api_response_modals(res);
                    bus.$emit('sales_plan_updated', true);
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = this.items[item.row_id].id;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteVisitorArea";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
